// Horizontal Product Block - handles variant selection, subscription frequency, and pricing updates

// Store block-specific data
window.hpbBlocks = window.hpbBlocks || {};

function initHorizontalProductBlock(blockId) {
  const formatMoney = (cents) => {
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(cents / 100);
  };

  function updateHorizontalPrice(targetBlockId) {
    const actualBlockId = targetBlockId || blockId;
    const block = document.querySelector(
      `.horizontal-product-block[data-block-id="${actualBlockId}"]`,
    );
    if (!block) return;

    const selectedOption = block.querySelector(
      ".horizontal-product-option.selected",
    );
    if (!selectedOption) return;

    const subDiscount =
      parseFloat(block.getAttribute("data-sub-discount") || 0) / 100;
    const showSubSelector =
      block.getAttribute("data-show-sub-selector") === "true";
    const defaultToSub = block.getAttribute("data-default-to-sub") === "true";
    const showCostPerItem =
      block.getAttribute("data-show-cost-per-item") === "true";

    // Determine if subscription is active
    let isSubscribed = false;
    if (showSubSelector) {
      // Use the selected radio button value
      const selectedInput = block.querySelector(
        ".frequency-option.selected input",
      );
      isSubscribed = selectedInput?.value === "subscription";
    } else {
      // Use the default setting when selector is hidden
      isSubscribed = defaultToSub;
    }

    const quantity = parseInt(
      block.querySelector(".quantity-input")?.value || 1,
    );

    // Update individual option displays
    block.querySelectorAll(".horizontal-product-option").forEach((option) => {
      const basePrice = parseFloat(
        option.getAttribute("data-variant-price") || 0,
      );
      const unitPrice = parseFloat(
        option.getAttribute("data-variant-unit-price") || 0,
      );
      const comparePrice = parseFloat(
        option.getAttribute("data-variant-compare-price") || basePrice,
      );

      let displayUnitPrice = unitPrice;
      let displayPrice = basePrice;
      let displayUnitComparePrice = (comparePrice / basePrice) * unitPrice;

      if (isSubscribed) {
        displayUnitPrice = unitPrice * (1 - subDiscount);
        displayPrice = basePrice * (1 - subDiscount);
      }

      option
        .querySelectorAll(".unit-price-display")
        .forEach((el) => (el.textContent = formatMoney(displayUnitPrice)));
      option.querySelectorAll(".unit-compare-price-display").forEach((el) => {
        if (displayUnitComparePrice > displayUnitPrice) {
          el.textContent = formatMoney(displayUnitComparePrice);
          el.style.display = "inline";
        } else {
          el.style.display = "none";
        }
      });
      option
        .querySelectorAll(".price-display")
        .forEach((el) => (el.textContent = formatMoney(displayPrice)));
      option
        .querySelectorAll(".compare-price-display")
        .forEach((el) => (el.textContent = formatMoney(comparePrice)));
    });

    const selectedBasePrice = parseFloat(
      selectedOption.getAttribute("data-variant-price"),
    );
    const selectedComparePrice = parseFloat(
      selectedOption.getAttribute("data-variant-compare-price") ||
      selectedBasePrice,
    );

    let finalPrice = selectedBasePrice * quantity;
    let finalComparePrice = selectedComparePrice * quantity;

    if (isSubscribed) {
      finalPrice = finalPrice * (1 - subDiscount);
    }

    // Update One-time prices in footer (may be repositioned outside block)
    const footerContent = document.getElementById(
      `hpb-footer-content-${actualBlockId}`,
    );
    const oneTimeCurrent =
      footerContent?.querySelector(".one-time-current-price") ||
      block.querySelector(".one-time-current-price");
    if (oneTimeCurrent) {
      oneTimeCurrent.textContent = formatMoney(selectedBasePrice * quantity);
    }
    const oneTimeCompare =
      footerContent?.querySelector(".one-time-compare-price") ||
      block.querySelector(".one-time-compare-price");
    if (oneTimeCompare) {
      if (selectedComparePrice > selectedBasePrice) {
        oneTimeCompare.textContent = formatMoney(
          selectedComparePrice * quantity,
        );
        oneTimeCompare.style.display = "inline";
      } else {
        oneTimeCompare.style.display = "none";
      }
    }

    // Update "Add to Cart" Button
    const section = block.closest(".shopify-section");
    const submitButton =
      section?.querySelector(".product-form__submit") ||
      section?.querySelector(".shop-add-to-cart-button");
    const buttonTextSpan =
      submitButton?.querySelector(".button-text") ||
      submitButton?.querySelector("span");

    if (buttonTextSpan) {
      const baseText = "Buy Now";

      let newContent = baseText + ` - ${formatMoney(finalPrice)}`;
      if (finalComparePrice > finalPrice) {
        newContent += ` <span class="compare-price">(${formatMoney(finalComparePrice)})</span>`;
      }

      buttonTextSpan.innerHTML = newContent;
    }

    // Update Shopify standard forms - only within this product's section
    const forms = section
      ? section.querySelectorAll('form[action*="/cart/add"]')
      : [];

    forms.forEach((form) => {
      const qInput = form.querySelector('input[name="quantity"]');
      if (qInput) qInput.value = quantity;

      // Handle selling plan input - create if doesn't exist
      let spInput = form.querySelector('input[name="selling_plan"]');
      let selectedSpId = selectedOption.getAttribute("data-selling-plan-id");

      // Fallback to block's global selling plan if option is missing it
      if (!selectedSpId) {
        selectedSpId = block.getAttribute("data-first-selling-plan-id");
      }

      if (isSubscribed && selectedSpId && selectedSpId !== "") {
        // Need subscription - ensure input exists and set value
        if (!spInput) {
          spInput = document.createElement("input");
          spInput.type = "hidden";
          spInput.name = "selling_plan";
          form.appendChild(spInput);
        }
        spInput.value = selectedSpId;
      } else {
        // One-time purchase or no selling plan available - remove selling_plan if it exists
        if (spInput) {
          spInput.remove();
        }
      }

      const idInput = form.querySelector('input[name="id"]');
      if (idInput) {
        idInput.value = selectedOption.getAttribute("data-variant-id");
      }
    });

    // One-time purchase link visibility is controlled by Liquid settings only
    // Don't toggle it dynamically - it should remain visible if enabled in settings

    // Reposition footer content below the button if not already there
    if (footerContent && submitButton && !footerContent.dataset.repositioned) {
      submitButton.parentNode.insertBefore(
        footerContent,
        submitButton.nextSibling,
      );
      footerContent.dataset.repositioned = "true";
    }
  }

  // Store functions globally but namespace them
  window.hpbBlocks[blockId] = { updateHorizontalPrice };

  // Initialize on load
  document.addEventListener("DOMContentLoaded", () =>
    setTimeout(() => updateHorizontalPrice(blockId), 200),
  );
  if (
    document.readyState === "complete" ||
    document.readyState === "interactive"
  )
    setTimeout(() => updateHorizontalPrice(blockId), 200);
}

// Global functions that work across all blocks

window.selectHorizontalOption = function (element, variantId) {
  const block = element.closest(".horizontal-product-block");
  if (!block) return;

  const targetBlockId = block.getAttribute("data-block-id");

  block
    .querySelectorAll(".horizontal-product-option")
    .forEach((el) => el.classList.remove("selected"));
  element.classList.add("selected");

  const mediaId = element.getAttribute("data-media-id");

  // Only update variant inputs within this product's section
  const section = block.closest(".shopify-section");
  const variantInputs = section
    ? section.querySelectorAll('input[name="id"]')
    : [];
  variantInputs.forEach((input) => {
    input.value = variantId;
    input.dispatchEvent(new Event("change", { bubbles: true }));
  });

  // Dispatch event for gallery
  document.dispatchEvent(
    new CustomEvent("variantImageSelected", {
      detail: {
        variantId: variantId,
        mediaId: mediaId,
      },
    }),
  );

  if (window.hpbBlocks[targetBlockId]) {
    window.hpbBlocks[targetBlockId].updateHorizontalPrice(targetBlockId);
  }
};

window.selectFrequency = function (type, targetBlockId) {
  const block = document.querySelector(
    `.horizontal-product-block[data-block-id="${targetBlockId}"]`,
  );
  if (!block) return;

  const options = block.querySelectorAll(".frequency-option");
  const frequencySelector = block.querySelector(
    ".horizontal-frequency-selector",
  );
  const autoshipBenefits = block.querySelector(".autoship-benefits");

  // Toggle benefits visibility and autoship-active class on selector
  if (frequencySelector) {
    if (type === "subscription") {
      frequencySelector.classList.add("autoship-active");
    } else {
      frequencySelector.classList.remove("autoship-active");
    }
  }
  if (autoshipBenefits) {
    // Clear any pending timeout to prevent race conditions (e.g. rapid toggling)
    if (window.hpbBlocks[targetBlockId] && window.hpbBlocks[targetBlockId].benefitsTimeout) {
      clearTimeout(window.hpbBlocks[targetBlockId].benefitsTimeout);
    }
    // Ensure the block object exists
    window.hpbBlocks[targetBlockId] = window.hpbBlocks[targetBlockId] || {};

    if (type === "subscription") {
      autoshipBenefits.style.display = "block";
      // Force reflow to ensure transition runs if it was just hidden
      void autoshipBenefits.offsetWidth;

      autoshipBenefits.style.transition = "all 0.3s ease";
      autoshipBenefits.style.opacity = "1";
      autoshipBenefits.style.transform = "translateY(0)";
    } else {
      autoshipBenefits.style.transition = "all 0.3s ease";
      autoshipBenefits.style.opacity = "0";
      autoshipBenefits.style.transform = "translateY(-10px)";

      window.hpbBlocks[targetBlockId].benefitsTimeout = setTimeout(() => {
        autoshipBenefits.style.display = "none";
      }, 300);
    }
  }

  // Update frequency selection UI
  if (options.length > 0) {
    options.forEach((opt) => {
      const input = opt.querySelector("input");
      if (input.value === type) {
        opt.classList.add("selected");
        input.checked = true;
      } else {
        opt.classList.remove("selected");
        input.checked = false;
      }
    });
  }

  // Dynamically update variant discount badges
  const variantOptions = block.querySelectorAll(".horizontal-product-option");
  variantOptions.forEach((vOpt) => {
    const badge = vOpt.querySelector(".variant-save-badge");
    if (badge) {
      const oneTimeSavings = parseInt(
        vOpt.getAttribute("data-one-time-savings") || "0",
      );
      const subSavings = parseInt(vOpt.getAttribute("data-sub-savings") || "0");

      const currentSavings =
        type === "subscription" ? subSavings : oneTimeSavings;

      if (currentSavings > 0) {
        badge.textContent = `${currentSavings}% OFF`;
        badge.style.display = "inline-block";
      } else {
        badge.style.display = "none";
      }
    }
  });

  if (window.hpbBlocks[targetBlockId]) {
    window.hpbBlocks[targetBlockId].updateHorizontalPrice(targetBlockId);
  }
};

window.updateSellingPlan = function (select, targetBlockId) {
  // Selling plan is now handled dynamically per variant in updateHorizontalPrice
  if (window.hpbBlocks[targetBlockId]) {
    window.hpbBlocks[targetBlockId].updateHorizontalPrice(targetBlockId);
  }
};

window.addOneTimePurchase = function (targetBlockId) {
  // Find and submit the product form WITHOUT changing the page state
  const section = document
    .querySelector(`[data-block-id="${targetBlockId}"]`)
    ?.closest(".shopify-section");
  if (!section) return;

  const form = section.querySelector('form[action*="/cart/add"]');
  const productForm = section.querySelector("product-form");

  if (form && productForm) {
    // Temporarily remove selling_plan for this submission only
    const spInput = form.querySelector('input[name="selling_plan"]');
    const hadSellingPlan = !!spInput;
    const sellingPlanValue = spInput ? spInput.value : null;

    if (spInput) spInput.remove();

    // Trigger the form submission
    form.requestSubmit();

    // Restore selling_plan after submission so page state remains subscription
    if (hadSellingPlan && sellingPlanValue) {
      setTimeout(() => {
        const newSpInput = document.createElement("input");
        newSpInput.type = "hidden";
        newSpInput.name = "selling_plan";
        newSpInput.value = sellingPlanValue;
        form.appendChild(newSpInput);
      }, 100);
    }
  }
};

window.updateQuantity = function (diff, element) {
  const block = element.closest(".horizontal-product-block");
  if (!block) return;

  const targetBlockId = block.getAttribute("data-block-id");
  const input = block.querySelector(".quantity-input");
  if (!input) return;

  let val = parseInt(input.value) + diff;
  if (val < 1) val = 1;
  input.value = val;

  if (window.hpbBlocks[targetBlockId]) {
    window.hpbBlocks[targetBlockId].updateHorizontalPrice(targetBlockId);
  }
};

// Export init function
window.initHorizontalProductBlock = initHorizontalProductBlock;
